enum ErrorType {
	Network = "Network",
	Default = "Default",
	Git = "Git",
	Silent = "Silent",
	Parse = "Parse",
	NetworkApi = "NetworkApi",
}

export default ErrorType;
